import React from "react";

import "./TopPanel.scss";
import { MoneyCorpPermissions } from "../../hooks/usePermissions/usePermissions";

const TopPanel = (props: { permissions?: MoneyCorpPermissions }) => {
  return (
    <div className="TopPanel--container">
      <div className="TopPanel--logo" />
      <div className="TopPanel--links-container">
        <a href="/#" className="TopPanel--link-home">
          Home
        </a>
        <a href="/#" className="TopPanel--link-contact-us">
          Contact Us
        </a>
        {props.permissions && props.permissions.resetPassword && (
          <a href="/resetPassword" className="TopPanel--link-reset-password">
            Reset Password
          </a>
        )}
      </div>
    </div>
  );
};

export default TopPanel;
